var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app_root"}},[_c('header-navigator'),_c('v-content',[_c('router-view'),_c('small',{staticClass:"copy"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" emoooo")])],1),_c('footer-navigator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }